export const Roles = Object.freeze({
  USER: "USER",
  OWNER: "OWNER",
  SUPERUSER: "SUPERUSER",
  VERIFIED_EMAIL: "VERIFIED_EMAIL",
  VERIFIED_PHONE: "VERIFIED_PHONE",
  OAUTH2_GOOGLE: "OAUTH2_GOOGLE",
  OAUTH2_FACEBOOK: "OAUTH2_FACEBOOK"
});
